import { render } from "./RejectedLeads.vue?vue&type=template&id=0d8b4760&scoped=true"
import script from "./RejectedLeads.vue?vue&type=script&lang=js"
export * from "./RejectedLeads.vue?vue&type=script&lang=js"

import "./RejectedLeads.vue?vue&type=style&index=0&id=0d8b4760&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8b4760"]])

export default __exports__